
<template>
  <div class="CommentMod">
    <span class="commentNum">共{{ CommentNum }}条评论</span>
    <div class="commentcont">
      <ul style="height:calc(100% - 40px);overflow-y: auto;">
        <li v-for="(item, index) in commentData" :key="index" class="listmod">
          <div>
            <div class="listhead">
              <img :src="item.ReplyerImg ? item.ReplyerImg : require('../assets/other.png')" />
              <div>
                <h3>{{ item.ReplyerName }}</h3>
                <span style="margin-right: 8px; font-size: 12px">{{
                  item.HospitalName
                }}</span>
                <span style="font-size: 12px">{{ item.DepartmentName }}</span>
              </div>
            </div>
            <div class="listcont">
              <viewer :images="item.ImgUrl ? [item.ImgUrl] : []" v-if="item.ImgUrl">
                <img
                  :key="index"
                  :src="item.ImgUrl ? item.ImgUrl : ''"
                  style="margin-right: 12px; width: 180px; height: 120px"
                />
              </viewer>
              {{ item.Comment }}
            </div>
            <div class="listfoot">
              <span>{{
                item.CrtDate ? item.CrtDate.replace("T", " ") : ""
              }}</span>
              <div class="replybtn" @click="replyDad(item)">
                <Icon type="ios-chatbubbles-outline" />回复
              </div>
            </div>
          </div>
          <div
            v-if="IsDad == item.ReplyerName && IsDadid == item.ID"
            class="replylist replyinput"
          >
            <div>
              回复 <span style="color: #2d8cf0">{{ item.ReplyerName }}</span>
            </div>
            <Input
              v-model="dadReply"
              placeholder="请输入内容"
            />
            <div style="text-align: right; margin: 10px 0 5px">
              <Button type="primary" @click="cancelDad()">取消</Button>
              &emsp;
              <Button type="primary" :loading="loading" @click="sendDad(item)">发送</Button>
            </div>
          </div>
          <div class="replymod">
            <ul class="replyul">
              <li
                v-for="(ite, idx) in item.replyData"
                :key="idx"
                class="replylist"
              >
                <div class="replycont">
                  <div class="topHead">
                    <img
                      :src="ite.ReplyerImg ? ite.ReplyerImg : require('../assets/other.png')"
                      alt=""
                      style="
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-right: 2px;
                      "
                    />
                    <div style="margin-top: 8px">
                      <span>{{ ite.ReplyerName }}</span> 回复
                      <span>{{ ite.ByReplyerName }}</span>
                    </div>
                  </div>
                  <p style="margin: 3px 0px 0 45px">
                    {{ ite.Comment }}
                  </p>
                </div>
                <div class="replyfoot">
                  <!-- <span>{{ite.ReplyerName}}</span> -->
                  <span>{{ite.CrtDate ? ite.CrtDate.replace("T", " ") : ""}}</span>
                  <div class="replybtn" @click="replySon(ite)">回复</div>
                </div>
                <div
                  v-if="IsSon == ite.ReplyerName && IsSonid == ite.ID"
                  class="replylist replyinput"
                >
                  <div>
                    回复
                    <span style="color: #2d8cf0">{{ ite.ReplyerName }}</span>
                  </div>
                  <Input
                    v-model="sonReply"
                    placeholder="请输入内容"
                  />
                  <div style="text-align: right; margin: 10px 0 5px">
                    <Button type="primary" @click="cancelSon()">取消</Button>
                    &emsp;
                    <Button type="primary" :loading="loading" @click="sendSon(item, ite)"
                      >发送</Button
                    >
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="inputBox">
          <img
            :src="stroge.ImgUrl"
            alt=""
            style="width: 40px; height: 40px; border-radius: 20px;"
          />
          <Input
            @on-keydown.8="anxia"
            v-model="replyvalue"
            placeholder="请发表评论"
            style="width: 795px"
            
          />
          <div class="upload">
            <Upload
              :action="uploadfileUrl"
              accept="image/*"
              :on-success="uploadImg"
              :show-upload-list="false"
              :before-upload="beforeUpload"
              :on-error="uploadError"
            >
              <Icon size="24" type="ios-add-circle-outline" />
            </Upload>
            <Spin size="large" fix v-if="loading1">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>图片上传中</div>
            </Spin>
          </div>
          <Icon
            type="ios-at-outline"
            size="24"
            color="#1890FF"
            style="font-weight: 900"
            @click="GetDoctor"
          />
          <Button type="primary" :loading="loading" @click="publish()">发表</Button>
      </div>
    </div>

    <Modal
      class-name="doctor"
      v-model="doctor"
      title="@医生"
      @on-ok="sureDoc"
      @on-cancel="cancel"
    >
      <Row class="modalmain">
        <Col span="12">
          <div class="doctorlist">
            <div style="border-bottom: 1px solid #e9e9e9; margin-bottom: 6px">
              <Checkbox
                :indeterminate="indeterminate"
                :value="checkAll"
                @click.prevent.native="CheckAll"
                >全选</Checkbox
              >
            </div>
            <CheckboxGroup v-model="Checkdoctor" @on-change="CheckdoctorChange">
              <Checkbox
                v-for="(item, index) in doctorList"
                :key="item.ID"
                :label="item.ID"
              >
                <img :src="item.Img" style="margin-right: 5px" />
                <span>{{ item.DocName }}</span>
              </Checkbox>
            </CheckboxGroup>
          </div>
        </Col>
        <Col span="12">
          <div class="">
            <Tag
              v-for="(item, index) in ShowDoctor"
              :key="index"
              :name="item.DocName"
              closable
              @on-close="HandlemodalClose(index)"
              >{{ item.DocName }}</Tag
            >
          </div>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import {
  Icon,
  Input,
  Button,
  Modal,
  Row,
  Col,
  Checkbox,
  CheckboxGroup,
  Upload,
  Tag,
  Spin
} from "view-design";
import Config from "../config/index";
import Request from "../utils/request";
import dayjs from "dayjs";
import _ from "lodash";
const replyComment = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //回复评论post
const getCommentList = Config.SXG_baseUrl + "/api/currency/GetRecordDetail"; //获取评论列表get（完成）
const GetCommentDoctor =
  Config.SXG_baseUrl + "/api/casemanager/GetPartakeDocList"; //获取参与医生列表（完成）
const getCommentNum = Config.SXG_baseUrl + "/api/casemanager/GetCommentCount"; //获取评论数量（完成）
const inviteDoctor = Config.SXG_baseUrl + "/api/currency/GetRecordDetail";
const AddOperation = Config.SXG_baseUrl + "/api/casemanager/AddOperation"; //编辑保存信息的操作历史
export default {
  components: {
    Icon,
    Input,
    Button,
    Modal,
    Row,
    Col,
    Checkbox,
    CheckboxGroup,
    Upload,
    Tag,
    Spin
  },
  props: {
    patientName: String,
    joinDoctor:Array
  },
  // model: {
  //   event: "typeswitch",
  // },
  data() {
    return {
      loading1:false,
      loading:false,
      AtJID: [],
      AtName: [],
      AtImg: [],
      professionalList: [], //图片
      checkdoctorList: [],
      dadReply: "", //主回复内容
      sonReply: "", //子回复内容
      IsDad: "",
      IsDadid: "",
      IsSon: "",
      IsSonid: "",
      stroge: JSON.parse(localStorage.getItem("Role")),
      CommentNum: "",
      CommentDocInfo: [],
      DocUserJid: [], //医生的UserJid
      id: this.$route.params.id,
      //emotion:false,//表清包弹窗
      commentShow: false, //评论作者的区域
      textvalue: "", //评论作者的内容
      uploadfileUrl: Config.SXG_baseUrl + "/api/currency/uploadfile",
      replyvalue: "", //回复被回复人的内容
      replyvalue1: "",
      doctor: false, //@医生列表
      indeterminate: false,
      checkAll: false,
      Checkdoctor: [],
      doctorList: [],
      commentData: [
        {
          replyData: [], //子评论
        },
      ],
      SonReplay: [], //子评论
    };
  },
  computed: {
    ShowDoctor() {
      var newarr = [];
      newarr = _.intersectionWith(
        this.doctorList,
        this.Checkdoctor,
        function (key, val) {
          return key.ID == val;
        }
      );
      return newarr;
    },
  },
  methods: {
    //@医生的列表
    GetDoctor() {
      // this.AtJID = []
      this.doctor = true
      console.log(this.joinDoctor)
      let newarr = [];
      for (var i = 0; i < this.joinDoctor.length; i++) {
        if(this.joinDoctor[i].UserJid !=this.stroge.UserJid){
          var vote = {
            ID: this.joinDoctor[i].ID,
            DocName: this.joinDoctor[i].DocName,
            Img: this.joinDoctor[i].ImgUrl,
            UserJid: this.joinDoctor[i].UserJid,
          };
          newarr.push(vote);
        }
        
      }
      this.checkdoctorList = this.joinDoctor.map((item) => {
        return item.ID;
      });
      this.doctorList = newarr;
      
    },
    //获取评论数量
    getCommentNum() {
      Request.getRequest(getCommentNum, {
        CaseID: this.id,
      }).then((res) => {
        this.CommentNum = res.data[0].count;
        //console.log(res,111111111111)
      });
    },
    //获取主评论列表
    getComment(IsPublish) {
      Request.getRequest(getCommentList, {
        tablename: "UserComment",
        searchkey2: "CaseID",
        searchvalue2: this.id,
        searchkey3: "IsMain",
        searchvalue3: "T",
      }).then((res) => {
        if (res.code == 200) {
        //  console.log(res, "获取的主评论");
          this.commentData = res.data;
          this.commentData.map((item) => {
            this.DocUserJid.push(item.ReplyerJID);
            this.getSonComment(item.ID);
          });
          if(this.commentData.length){
            this.commentData[this.commentData.length-1].Islast = true
          }
          this.GetCommentDoctor();
          //console.log(this.commentData,1111111111)
          if(IsPublish){
            this.scrollToBottom()
          }
          setTimeout(()=>{
            if(this.commentData.length){
              if(this.commentData[this.commentData.length-1].replyData.length != 0){
                this.commentData[this.commentData.length-1].replyData[(this.commentData[this.commentData.length-1].replyData).length-1].IsSonLast = true
              }
            }
             
            // this.commentData[this.commentData.length-1].replyData[(this.commentData[this.commentData.length-1].replyData).length-1].IsSonLast = true
          },1000)
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //获取参与医生列表
    GetCommentDoctor() {
      //console.log(this.DocUserJid.join(","),12121221)
      Request.getRequest(GetCommentDoctor, {
        UserJid: this.DocUserJid.join(","),
      }).then((res) => {
        //console.log(res, "参与医生列表");
        if (res.code == 200) {
          //console.log(res)
          this.CommentDocInfo = res.data;
          let arr = this.CommentDocInfo;
          for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < this.commentData.length; j++) {
              if (arr[i].UserJid == this.commentData[j].ReplyerJID) {
                this.commentData[j].HospitalName = arr[i].HospitalName;
                this.commentData[j].DepartmentName = arr[i].DepartmentName;
              }
            }
          }
          this.$forceUpdate();
          //console.log(this.commentData, "评论医生");
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //获取子回复内容
    getSonComment(id) {
      Request.getRequest(getCommentList, {
        tablename: "UserComment",
        searchkey2: "CaseID",
        searchvalue2: this.id,
        searchkey3: "PID",
        searchvalue3: id,
      }).then((res) => {
        if (res.code == 200) {
          //console.log(res, "获取的子评论");
          
          //this.SonReplay = res.data
          this.commentData.map((item) => {
            if (item.ID == id) {
              item.replyData = res.data;
            }
          });
          this.$forceUpdate();
          //console.log(this.commentData, 3333333333);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //回复主评论
    replyDad(item) {
      this.IsDad = item.ReplyerName;
      this.IsDadid = item.ID;
      if(item.Islast){
        this.scrollToBottom()
      }
    },
    cancelDad() {
      this.IsDad = "";
      this.IsDadid = "";
    },
    //回复主评论
    sendDad(item) {
      if(this.dadReply == ""){
        this.$Message.error("请输入内容");
      }else{
          this.loading = true
          Request.postRequest(replyComment, {
          tablename: "UserComment",
          CaseID: this.id,
          PID: item.ID,
          Comment: this.dadReply,
          ImgUrl: "",
          ByReplyerJID: item.ReplyerJID,
          ByReplyerName: item.ReplyerName,
          ByReplyerImg: item.ReplyerImg,
          ReplyerJID: this.stroge.UserJid,
          ReplyerName: this.stroge.DocName,
          ReplyerImg: this.stroge.ImgUrl,
          AtJID: "",
          AtName: "",
          AtImg: "",
          IsMain: "F",
        }).then((res) => {
          //console.log(res, "回复主评论");
          this.IsDad = "";
          this.IsDadid = "";
          this.dadReply = "";
          this.sonReply = "";
          this.getComment(false);
          this.getCommentNum();
          this.loading = false
        });
      }
      
    },

    //回复子评论
    replySon(ite) {
      console.log(ite)
      this.IsSon = ite.ReplyerName;
      this.IsSonid = ite.ID;
      if(ite.IsSonLast){
        this.scrollToBottom()
      }
    },
    cancelSon() {
      this.IsSon = "";
      this.IsSonid = "";
    },
    sendSon(item, ite) {
      if(this.sonReply == ""){
        this.$Message.error("请输入内容");
      }else{
        this.loading = true
          //console.log(item, ite, 121212121);
          Request.postRequest(replyComment, {
          tablename: "UserComment",
          CaseID: this.id,
          PID: item.ID,
          Comment: this.sonReply,
          ImgUrl: "",
          ByReplyerJID: ite.ReplyerJID,
          ByReplyerName: ite.ReplyerName,
          ByReplyerImg: ite.ReplyerImg,
          ReplyerJID: this.stroge.UserJid,
          ReplyerName: this.stroge.DocName,
          ReplyerImg: this.stroge.ImgUrl,
          AtJID: "",
          AtName: "",
          AtImg: "",
          IsMain: "F",
        }).then((res) => {
          console.log(res, "回复子评论");
          this.IsSon = "";
          this.IsSonid = "";
          this.dadReply = "";
          this.sonReply = "";
          this.getComment(false);
          this.getCommentNum();
          this.loading = false
        });
      }
      
      
    },
    //发表评论
    publish() {
      if(this.replyvalue == ""){
        return this.$Message.info("请输入内容")
      }
      this.loading = true
      //console.log(JSON.stringify(this.professionalList), 1212121212);
      Request.postRequest(replyComment, {
        tablename: "UserComment",
        CaseID: this.id,
        PID: "",
        Comment: this.replyvalue,
        ImgUrl: "",
        ByReplyerJID: "",
        ByReplyerName: "",
        ByReplyerImg: "",
        ReplyerJID: this.stroge.UserJid,
        ReplyerName: this.stroge.DocName,
        ReplyerImg: this.stroge.ImgUrl,
        AtJID: this.AtJID ? this.AtJID.join(",") :'',
        AtName: this.AtName ? this.AtName.join(",") :'',
        AtImg: this.AtImg ? JSON.stringify(this.AtImg) :'',
        IsMain: "T",
      }).then((res) => {
        if(res.code == 200){
          //console.log(res, "发表评论成功");
          this.replyvalue = "";
          this.getComment(true);
          this.getCommentNum();
          this.loading = false
          Request.postRequest(AddOperation,{
            CaseID:this.id,
            Dynamic:`<span>${this.stroge.DocName}</span>在<em>${this.patientName}</em>的案例中发布留言`,
            OperationHis:`<span>${this.stroge.DocName}</span>发布留言`,
            OUserJid:this.stroge.UserJid,
            ODocName:this.stroge.DocName,
            ToUser:JSON.stringify(this.AtJID),
            Type:"讨论新增",
            OImg:this.stroge.ImgUrl,
            CenterID:this.stroge.CenterID
          }).then(res=>{
            if(res.code == 200){
              console.log("发布讨论操作历史")
              this.$emit("AddOperation")
            }else{
              this.$Message.error(res.message)
            }
          })
        }else{
          this.$Message.error(res.message)
        }
      });
    },
    /* @医生确定按钮 */
    sureDoc() {
      this.AtJID = []
      this.ShowDoctor.map(item=>{
        this.replyvalue =  this.replyvalue += '@' + item.DocName + ':'
        this.AtJID.push(item.UserJid)
        // this.AtName.push(item.DocName)
        // this.AtImg.push(item.Img)
      })
      this.Checkdoctor = []
      Request.postRequest(AddOperation,{
        CaseID:this.id,
        Dynamic:`<span>${this.stroge.DocName}</span>在<em>${this.patientName}</em>的案例中发布留言并@了您`,
        OUserJid:this.stroge.UserJid,
        ODocName:this.stroge.DocName,
        ToUser:JSON.stringify(this.AtJID),
        Type:"@",
        OImg:this.stroge.ImgUrl,
        CenterID:this.stroge.CenterID
      }).then(res=>{
        if(res.code == 200){
          console.log("@操作历史")
        }else{
          this.$Message.error(res.message)
        }
      })
    },

    /* 键盘按下事件 */
    anxia(e){
      let index1 = this.replyvalue.lastIndexOf('@')
      let index2 = this.replyvalue.lastIndexOf(':')
      // console.log('index',index1)
      // console.log('index',index2)
      // console.log('字符串长度',this.replyvalue.length)
      // console.log('删除',this.replyvalue.substring(index1,index2))
      if(index2+1==this.replyvalue.length){
        e.preventDefault()   
      this.replyvalue = this.replyvalue.replace(this.replyvalue.substring(index1,index2+1),'')           
      }
    },


    cancel() {},
    //全选
    CheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        this.Checkdoctor = this.checkdoctorList;
        // console.log(this.Checkdoctor,this.checkdoctorList,this.ShowDoctor,1)
      } else {
        this.Checkdoctor = [];
        // console.log(this.Checkdoctor,this.checkdoctorList,2)
      }
    },
    //多选数据改变的时候
    CheckdoctorChange(data) {
      console.log(data, this.Checkdoctor, this.checkdoctorList);
      if (data.length === this.checkdoctorList.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    //删除选中的
    HandlemodalClose(index) {
      this.Checkdoctor.splice(index, 1);
      this.checkAll = false;
      if (this.Checkdoctor.length) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
    /* 上传图片失败 */
    uploadError() {
      this.loading1 = false
      this.$Message.info("图片上传失败，请稍后再试");
    },
    /* 上传图片之前触发 */
    beforeUpload() {
      this.loading1 = true
      const check = this.professionalList.length < 1;
      if (!check) {
        this.$Notice.warning({
          title: "最多只能上传一张图片",
        });
      }
      return check;
    },
    /* 上传图片成功 */
    uploadImg(res) {
      this.loading1 = false
      if (res.code == 200) {
        this.professionalList.push(res.data[0]);
        Request.postRequest(replyComment, {
        tablename: "UserComment",
        CaseID: this.id,
        PID: "",
        Comment: this.replyvalue,
        ImgUrl: this.professionalList
          ? this.professionalList[0]
          : "",
        ByReplyerJID: "",
        ByReplyerName: "",
        ByReplyerImg: "",
        ReplyerJID: this.stroge.UserJid,
        ReplyerName: this.stroge.DocName,
        ReplyerImg: this.stroge.ImgUrl,
        AtJID: "",
        AtName: "",
        AtImg: "",
        IsMain: "T",
      }).then((res) => {
        console.log(res, "发表评论成功");
        //this.replyvalue = "";
        this.getComment(true);
        this.getCommentNum();
      });
      }
      this.professionalList = []
    },
    //滚动条始终在底部
    scrollToBottom() {
      this.$nextTick(() => {
        let box = this.$el.querySelector(".commentcont ul")
        box.scrollTop  = box.scrollHeight 
      })
    }
  },
  created() {    
    // this.scrollToBottom()
  },
  mounted() {
    this.getComment(true); //主评论
    this.getCommentNum(); //评论数量
    this.scrollToBottom()
  },

};
</script>

<style lang="less">
.CommentMod {
  height: 100%;
  .commentNum {
      position: absolute;
      right: 12px;
      top: 80px;
      color: grey;
    }
  .commentcont {
    width: 100%;
    height: 100%;
    padding: 24px 0 12px 0px;
    position: relative;
    .listmod {
      list-style: none;
      position: relative;
      padding: 20px 0 0 10px;
      border-bottom: 1px solid #e9e9e9;
      border-right: 1px solid #e9e9e9;
      &:last-child {
        border: none;
      }
      .listhead {
        display: flex;
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
          margin-top: 8px;
        }
        > div {
          flex: 1;
          h3 {
            font-size: 14px;
            line-height: 25px;
          }
          p {
            margin: 0;
            font-size: 12px;
            line-height: 20px;
            color: #999;
          }
        }
      }
      .listcont {
        padding: 5px 10px 5px 40px;
        line-height: 28px;
      }
      .listfoot {
        text-align: right;
        margin-right: 7px;
        margin-bottom: 12px;
        span {
          margin-right: 10px;
          color: #999;
        }
      }
      .replybtn {
        display: inline-block;
        color: #001791;
        cursor: pointer;
      }
      .replymod {
        margin: 0px 0px 10px 35px;
        //padding: 10px 10px 5px 18px;
        height: auto;
        background: #f7f8fa;

        .replylist {
          list-style: none;
          //line-height: 24px;
          padding: 7px 5px 0;
          border-bottom: 1px solid #dcdee2;
          &:last-child {
            border: none;
          }
          .replycont {
            display: flex;
            flex-direction: column;
            .topHead {
              display: flex;
            }
            span {
              color: #2d8cf0;
            }
          }
          .replyfoot {
            margin: 5px 0 0;
            text-align: right;
            span {
              margin-right: 7px;
              color: #999;
            }
          }
          .replyinput {
            padding: 10px 5px 7px;
            textarea.ivu-input {
              resize: none;
              margin-top: 3px;
            }
          }
        }
      }
    }
    
  }
  .inputBox {
      width: 100%;
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
}
.doctor {
  .ivu-modal {
    width: 400px !important;
  }
  .modalmain {
    height: 480px;
    .ivu-col {
      padding: 0 15px;
      height: 100%;
      overflow: auto;
      .doctorlist {
        margin: 10px 0;
        .ivu-checkbox-wrapper {
          display: block;
          line-height: 30px;
          margin: 10px 0;
          .ivu-checkbox {
            margin-right: 7px;
          }
          img {
            width: 30px;
            height: 30px;
            vertical-align: middle;
            border-radius: 50%;
          }
        }
      }
      .ivu-tag {
        height: auto;
      }
    }
  }
}
</style>